<template>
  <form @submit.prevent="submit">
    <div class="modal fade" id="order-modal" tabindex="-1" role="dialog" aria-labelledby="add-question" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" :class="{'modal-xl': !resp, 'modal-md': resp}" role="document">
        <template v-if="showOrder">
          <template v-if="!resp">
            <div class="modal-content" :class="{'danger': !isNoDanger}">
              <div class="modal-header">
                <div class="title-with-icon">
                  <div class="title-with-icon__icon title-with-icon__icon_partner"></div>
                  <div class="title-with-icon__title">Заявка на включение в экспертную базу Школы экспорта РЭЦ</div>
                </div>
                <button id="modal-close" type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-item">
                  <label for="name"><b>Выберите вид (вариант) сотрудничества со Школой экспорта РЭЦ</b></label>
                  <select required v-model="data.type">
                    <option v-for="type in [
                      'Автор-разработчик',
                      'Приглашенный преподаватель',
                      'Эксперт-консультант'
                  ]" :key="type" :value="type">
                      {{ type }}
                    </option>
                  </select>
                </div>
                <div class="form-item">
                  <label for="name"><b>ФИО</b></label>
                  <input v-model="data.fullname" id="name" class="form-control" required />
                </div>
                <div class="form-item">
                  <label for="citizenship"><b>Гражданство</b></label>
                  <input v-model="data.citizenship" id="citizenship" class="form-control" required />
                </div>
                <div class="form-item">
                  <label for="name"><b>Год рождения</b></label>
                  <input v-model="data.year" :class="{'is-invalid': data.year && data.year.length < 4}" v-imask="{mask: '0000',lazy: true}" id="year" class="form-control" required/>
                  <div class="invalid-feedback">
                    Проверьте правильность ввода года рождения
                  </div>
                </div>
                <div class="form-item">
                  <label for="phone-acel"><b>Номер телефона</b></label>
                  <input v-model="data.phone" v-imask="{mask: '+ {7} (000) 000 0000',lazy: true}" :class="{'is-invalid': isError}" class="form-control" id="phone-acel" required placeholder="+7 (999) 999 9999" />
                  <div class="invalid-feedback">
                    Проверьте правильность ввода номера
                  </div>
                </div>
                <div class="form-item">
                  <label for="email"><b>Email</b></label>
                  <input v-model="data.email" id="email" type="email" class="form-control" required />
                </div>
                <div class="form-item">
                  <label for="name"><b>Место работы, должность</b></label>
                  <input v-model="data.post" id="name" class="form-control" required />
                </div>
                <div class="form-item" :class="{'education': !isNoDanger}">
                  <label for="name"><b>Образование</b></label>
                  <select required v-model="data.education">
                    <option v-for="type in [
                      'Высшее образование',
                      'Среднее профессиональное образование',
                      'Среднее (полное) общее образование'
                  ]" :key="type" :value="type">
                      {{ type }}
                    </option>
                  </select>
                  <div v-if="!isNoDanger" class="invalid-feedback d-block">
                    К сожалению, Вы не соответствуете критериям отбора. К отбору допускаются только лица, имеющее высшее образование.
                  </div>
                </div>
                <div class="form-item">
                  <label for="name"><b>Область профессиональной экспертизы</b></label>
                  <multiselect
                      :max="3"
                      multiple
                      selectLabel=""
                      selectedLabel="Выбрано"
                      deselectLabel=""
                      v-model="data.branch"
                      placeholder=""
                      :options="[
                      'внешнеэкономическая деятельность',
                      'разработка стратегий социально-экономического, экспортного развития субъектов РФ',
                      'экспорт услуг (образовательные, туристические, медицинские, креативные индустрии)',
                      'экспорт физических товаров',
                      'проектное управление',
                      'экспортные и инвестиционные проекты',
                      'экономика и финансы',
                      'экспортный маркетинг и продажи',
                      'финансовое планирование экспортной деятельности',
                      'развитие кадрового потенциала',
                      'страновая специфика дружественных стран'
                  ]">
                    <template slot="maxElements">
                      Максимально можно выбрать только три элемента.
                    </template>
                  </multiselect>
                </div>
                <div class="form-item">
                  <label for="name"><b>Опыт работы в бизнесе,
                    опыт управленческого консультирования,
                    опыт взаимодействия с международными партерами из разных стран
                    (укажите период и место работы и\или название проектов, подтверждающих опыт)
                  </b></label>
                  <textarea class="form-control" required v-model="data.experience" maxlength="200"></textarea>
                </div>
                <div class="form-item d-flex justify-content-between p-24 fill-grey">
                  <div>
                    <label><b>Требования к содержанию и оформлению резюме</b></label>
                  </div>
                  <div>
                    <a href="https://exporteduru.servicecdn.ru/media/default/0002/92/94e6e4b3d74a1a01556367a4b12e9c45dd534065.pdf" target="_blank" class="btn btn-outline-primary btn-outline-primary-with-icon">
                      <svg class="mr-1" width='13' height='14' viewBox='0 0 13 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M4.02667 7.86004C3.96418 7.92202 3.91459 7.99575 3.88074 8.07699C3.84689 8.15823 3.82947 8.24537 3.82947 8.33337C3.82947 8.42138 3.84689 8.50852 3.88074 8.58976C3.91459 8.671 3.96418 8.74473 4.02667 8.80671L6.02667 10.8067C6.08864 10.8692 6.16238 10.9188 6.24362 10.9526C6.32486 10.9865 6.41199 11.0039 6.5 11.0039C6.58801 11.0039 6.67515 10.9865 6.75638 10.9526C6.83762 10.9188 6.91136 10.8692 6.97333 10.8067L8.97333 8.80671C9.09887 8.68117 9.16939 8.51091 9.16939 8.33337C9.16939 8.15584 9.09887 7.98558 8.97333 7.86004C8.8478 7.73451 8.67754 7.66398 8.5 7.66398C8.32247 7.66398 8.1522 7.73451 8.02667 7.86004L7.16667 8.72671V1.00004C7.16667 0.82323 7.09643 0.65366 6.9714 0.528636C6.84638 0.403612 6.67681 0.333374 6.5 0.333374C6.32319 0.333374 6.15362 0.403612 6.0286 0.528636C5.90357 0.65366 5.83333 0.82323 5.83333 1.00004V8.72671L4.97333 7.86004C4.91136 7.79756 4.83762 7.74796 4.75638 7.71411C4.67515 7.68027 4.58801 7.66284 4.5 7.66284C4.41199 7.66284 4.32486 7.68027 4.24362 7.71411C4.16238 7.74796 4.08864 7.79756 4.02667 7.86004ZM10.5 5.00004H9.16667C8.98986 5.00004 8.82029 5.07028 8.69526 5.1953C8.57024 5.32033 8.5 5.4899 8.5 5.66671C8.5 5.84352 8.57024 6.01309 8.69526 6.13811C8.82029 6.26314 8.98986 6.33337 9.16667 6.33337H10.5C10.6768 6.33337 10.8464 6.40361 10.9714 6.52864C11.0964 6.65366 11.1667 6.82323 11.1667 7.00004V11.6667C11.1667 11.8435 11.0964 12.0131 10.9714 12.1381C10.8464 12.2631 10.6768 12.3334 10.5 12.3334H2.5C2.32319 12.3334 2.15362 12.2631 2.0286 12.1381C1.90357 12.0131 1.83333 11.8435 1.83333 11.6667V7.00004C1.83333 6.82323 1.90357 6.65366 2.0286 6.52864C2.15362 6.40361 2.32319 6.33337 2.5 6.33337H3.83333C4.01014 6.33337 4.17971 6.26314 4.30474 6.13811C4.42976 6.01309 4.5 5.84352 4.5 5.66671C4.5 5.4899 4.42976 5.32033 4.30474 5.1953C4.17971 5.07028 4.01014 5.00004 3.83333 5.00004H2.5C1.96957 5.00004 1.46086 5.21075 1.08579 5.58583C0.710714 5.9609 0.5 6.46961 0.5 7.00004V11.6667C0.5 12.1971 0.710714 12.7058 1.08579 13.0809C1.46086 13.456 1.96957 13.6667 2.5 13.6667H10.5C11.0304 13.6667 11.5391 13.456 11.9142 13.0809C12.2893 12.7058 12.5 12.1971 12.5 11.6667V7.00004C12.5 6.46961 12.2893 5.9609 11.9142 5.58583C11.5391 5.21075 11.0304 5.00004 10.5 5.00004Z'/></svg>
                      Скачать
                    </a>
                  </div>
                </div>
                <div class="form-item">
                  <attach-file :required="true" v-model="data.attach" title="<b>Приложите Ваше резюме с подробным описанием полученного образования (в т.ч. дополнительного), опыта работы и профессиональной экспертизы</b>" />
                  <div v-if="!data.attach" class="invalid-feedback d-block">
                    Приложите файл
                  </div>
                </div>
              </div>
              <div class="modal-footer" style="justify-content: flex-end;">
                <div class="checkbox-wrapper modal-register-conditions">
                  <div class="checkbox">
                    <input name="солгасие" v-model="checked" type="checkbox" id="register-conditions"/>
                    <label for="register-conditions">Я согласен(на) с условиями <a href="https://exportedu.ru/agreement">пользовательского соглашения</a> и
                      <a target="_blank" href="https://exporteduru.servicecdn.ru/media/default/0003/12/afe4c45ca00400534ab0ec8b7cc4189169882841.pdf">политикой обработки персональных данных</a></label>
                  </div>
                </div>
                <button :disabled="!checked" type="submit" class="btn btn-primary"><span>Отправить заявку</span></button>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="modal-content form-result">
              <div class="modal-body">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <h2>Спасибо!</h2>
                    <p class="text-16">
                      Ваша заявка принята в работу!
                    </p>
                  </div>
                  <button @click="toProfile" type="button" data-dismiss="modal" aria-label="Close" class="btn btn-primary btn-lg btn-rounded mb-0">OK</button>
                </div>
              </div>
            </div>
          </template>
        </template>
        <div v-else class="modal-content container-shadow p-4">
          <div class="modal-header">
            <div class="title-with-icon">
              <div class="title-with-icon__icon title-with-icon__icon_login"></div>
              <div class="title-with-icon__title">Уважаемые  кандидаты в экспертную базу Школы экспорта РЭЦ!</div>
            </div>
            <button id="modal-close" type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <content-section>
              <p>Школа экспорта РЭЦ благодарит вас за проявленный интерес к участию в деятельности Школы экспорта РЭЦ.</p>
              <p>Сообщаем, что в настоящее время набор кандидатов в тренеры / наставники / эксперты Школы экспорта РЭЦ приостановлен по техническим причинам.</p>
              <p>Очередной набор будет объявлен в 2026 году.</p>
              <p class="mt-4">Желаем вам успехов в профессиональной деятельности и надеемся на плодотворное сотрудничество в будущем.</p>
            </content-section>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { IMaskDirective } from 'vue-imask';
import AttachFile from "@/components/AttachFile.vue";
import ApiService from "../../../services/api.service";
import 'vue-multiselect/dist/vue-multiselect.min.css'
import ContentSection from "@/components/content/ContentSection.vue";
export default {
  name: "ModalOrder",
  components: {ContentSection, AttachFile, Multiselect},
  directives: {
    imask: IMaskDirective
  },
  data() {
   return {
     data: {
       education: null
     },
     showOrder: false,
     checked: true,
     isError: false,
     resp: null
   }
  },
  computed: {
    isNoDanger() {
      return this.data.education === null || this.data.education === 'Высшее образование'
    }
  },
  methods: {
    toProfile() {
      //FIXME: for new LK!
      window.location.href = '/lk/settings/personal';
    },
    async submit() {
      if(!this.data.phone || this.data.phone.length < 18 || !this.data.attach) {
        this.isError = true
        return;
      } else {
        let resp = await ApiService.post('expert-orders', {
          ...this.data, ...{attach: this.data.attach.id}, ...{branch: this.data.branch.join(', ')}
        })
        if(resp.status === 201) {
          this.resp = resp.data
          this.isError = false
          this.data = {}
        } else {
          this.isError = true
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "src/assets/style/variables";
.form-result {
  background: url("/pic/ffg/union-up.svg") #fff center bottom no-repeat;
  .modal-body {
    padding: 0 4rem 0;
  }
  .btn-rounded {
    margin-bottom: 3.2rem;
    border-radius: 2.4rem;
  }
}
.modal-content  {
  &.danger {
    &:before {
      content: '';
      width: 100%;
      height: 100%;
      background: #fff;
      opacity: .5;
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
    }
  }
}
.form-item.education, .modal-header {
  z-index: 3;
}
</style>